import { useState, useRef, useEffect, useMemo } from "react";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import moment from "moment";
import { EventoService } from "../../../services/EventoService";
import { FormUtility } from "../../Utility/FormUtility";

export default function IseeAudit(props) {

    const eventoService = new EventoService();
    const utility = new FormUtility();
    const dtRef = useRef();

    

    const dtOptions = useMemo(() => {
        return {
        columns: [
            {
                name: "Id",
                data: "id",
                visible: true,
                sortable: false,
                searchable: false
            },
            {
                name: "Codice domanda",
                data: "",
                visible: true,
                sortable: false,
                searchable: true,
                cell: (row, col) => {
                    return row.oggetto.codiceDomanda;
                }
            },
            {
                name: "Id ISEE",
                data: "id",
                visible: true,
                sortable: false,
                searchable: false,
                cell: (row, col) => {
                    return row.oggetto.id;
                }
            },
            {
                name: "Azione",
                data: "azione",
                visible: true,
                sortable: true,
                searchable: true,
            },
            {
                name: "Esito",
                data: "oggetto",
                visible: true,
                sortable: true,
                searchable: false,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'esito');
                }
            },
            {
                name: "Numero componenti",
                data: "oggetto",
                visible: true,
                sortable: true,
                searchable: false,
                cell: (row, col) => {
                    if(!row.dataProcollo || row.dataProtocollo == 0) return "";
                    return utility.getValueFromObj(row.oggetto, 'numeroComponenti');
                }
            },
            {
                name: "Valore ISEE",
                data: "oggetto",
                visible: true,
                sortable: false,
                searchable: true,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'valore');
                }
            },
            {
                name: "Richiesta",
                data: "oggetto",
                visible: false,
                sortable: false,
                searchable: true,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'richiestaId');
                }
            },
            {
                name: "Data evento",
                data: "createdAt",
                visible: true,
                sortable: true,
                searchable: true,
                cell: (row, col) => {
                    return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
                }
            }
        ],
        serverSide: true,
        rows: [],
        sorts: [{name:'createdAt',direction:'desc'}],
        hideSearch: false,
        title: "Elenco eventi ISEE",
        ajax: eventoService.getAllDt,
        ajaxParams: {
            entity: ["Isee"],
            searchableItem: [
                "codice",
                "id",
                "valore",
                "numeroComponenti",
                "esito"
            ]
        },
        };
    }, []);

    return (
        <DataTableWrapper
            ref={dtRef}
            dtOptions={dtOptions}
        />
    );
}
